import { useEffect } from "react";

const Loading = () => {
    useEffect(() => {
        document.body.style.overflow = 'hidden'
        return () => document.body.style.overflow = 'auto'
    }, [])
    return (
        <>
            <div className="absolute bg-black bg-opacity-10 z-[999998] h-full w-full overflow-hidden">
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 centerOfParent flex-col z-[999999] bg-white rounded-3xl px-8 py-6 gap-6">
                    <div className="lg:w-[260px] lg:h-[126px] w-[130px] h-[63px] overflow-hidden centerOfParent">
                        <img
                            src="/images/Tonaliteh logo1.png"
                            width={100} height={100}
                            style={{ width: '100%', height: 'auto' }} // optional
                            alt="Tonaliteh"
                            className="py-2 object-contain"
                        />
                    </div>
                    <span className="text-3xl mr-4">Loading...</span>
                </div>
            </div>
        </>
    );
};

export default Loading;